import { styled } from '@mui/material/styles'

const StyledItem = styled('div')({
  marginBottom: 16,
})

const StyledItemWithoutTitle = styled('div')({
  marginBottom: 16,
  marginTop: -30,
})

export const useStyles = () => ({
  item: StyledItem,
  itemWithoutTitle: StyledItemWithoutTitle,
})
